<template>
  <router-link
    class="home-course-card text-light"
    :style="
      `background-image: linear-gradient(to bottom, transparent, #000A), url(${course.cover_vertical ||
        course.cover})`
    "
    :to="{
      name: 'course',
      params: {
        ...course
      }
    }"
  >
    <div class="content">
      <!-- <div class="small">{{ course.count_lessons }} AULAS</div> -->
      <!-- <h5 class="font-weight-bold">{{ course.title }}</h5> -->
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    course: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.home-course-card {
  background-color: black;
  text-align: left;
  padding: 0;
  height: 0;
  width: 100%;
  display: block;
  padding-bottom: 150%;
  background-size: cover;
  background-position-x: center;
  background-position-y: center;
  position: relative;

  .content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    padding: 16px;
    background-color: #0000;
    transition: background-color 0.2s;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  &:hover {
    .content {
      background-color: #0002;
    }
  }
}
</style>
